<template>
    <button class="font-app-bold"
            :class="{'is-selected': isSelected}"
            :aria-selected="(isSelected ? 'true' : 'false')"
            @click="clickEvent">
        {{ __(label) }}
    </button>
</template>
<script>
    export default {

        props: ['lang', 'course', 'label', 'value', 'type'],

        data() {
            return {
                filters: this.value
            }
        },

        methods: {
            clickEvent() {
                this.$emit('click', `App\\Models\\${this.course}`, this.lang, this.type)
            }
        },

        computed:{
            isSelected(){
                return this.filters.lang == this.lang && this.filters.course == `App\\Models\\${this.course}` && this.type == this.filters.type;
            }
        },
    }
</script>
